import SnLabel from '~/components/snui/v2/snLabel/snLabel'

export default {
  components: { SnLabel },
  props: {
    labelProps: {
      type: [Object, String],
      default: null
    }
  },
  computed: {
    effectiveLabelProps () {
      const title = this.$attrs.label || this.labelProps?.title
      if (!title) return null

      var props = { title: title }

      if (typeof this.labelProps === 'string') {
        this.labelProps.split(',').forEach(item => {
          item = item.trim()
          if (item) props[item] = true
        })
      } else if (this.labelProps) {
        props = { ...this.labelProps, ...props }
      }

      if (this.dataCy) {
        props['data-cy'] = `${this.dataCy}-label`
      }

      return props
    }
  }
}
